interface SEOSchemaProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SEOSchema({ type, data = {} }: SEOSchemaProps) {
  const baseOrganization = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '乳色吐息动漫粉丝站',
    url: 'https://eezzz.cn',
    description: '乳色吐息动漫完整剧情介绍、角色分析与观看指南。最全面的乳色吐息动漫粉丝内容平台。',
  };

  const baseWebsite = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '乳色吐息动漫 — 官方正版资源与剧情解析',
    url: 'https://eezzz.cn',
    description: '乳色吐息动漫完整剧情介绍、角色分析与观看指南。深入解析乳色吐息动漫的故事背景、人物关系与艺术风格。',
    inLanguage: 'zh-Hans',
  };

  const baseWebPage = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    ...data,
  };

  const schemas: Record<string, Record<string, unknown>> = {
    Organization: baseOrganization,
    WebSite: baseWebsite,
    WebPage: baseWebPage,
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      ...data,
    },
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(schemas[type] || {})}
    </script>
  );
}